import { useEffect, useRef, useState } from 'react'

import { DATE_CONSTANTS } from '@/domain/constants/date'

type Props = {
  onInactivityAction?: () => void
  inactiveSeconds?: number
}

export const useTrackUserInactivity = ({
  onInactivityAction,
  inactiveSeconds = 30,
}: Props) => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null)
  const [isInactive, setIsInactive] = useState(false)

  const startInactivityCheck = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }
    timeoutId.current = setTimeout(() => {
      setIsInactive(true)
      onInactivityAction?.()
    }, DATE_CONSTANTS.TIME_IN_MILLISECONDS.SECOND * inactiveSeconds)
  }

  const resetInactivityCheck = () => {
    startInactivityCheck()
    setIsInactive(false)
  }

  useEffect(() => {
    startInactivityCheck()

    const events = ['mousemove', 'keydown', 'scroll', 'click']
    events.forEach((event) => {
      window.addEventListener(event, startInactivityCheck)
    })

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, startInactivityCheck)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    resetInactivityCheck,
    isInactive,
  }
}
